<template>
  <div class="wrapper">
    <div id="headFixed" :class="headIsFixed?'isfixed':''">
      <cart-head headTitle="我的购物车"></cart-head>
    </div>
    <div v-show="cartList.length==0" class="shop-container cart-empty">
      <h2>您的购物车还是空的</h2>
      <div class="btn">
        <router-link :to="{name:'search'}">马上去购物</router-link>
      </div>
    </div>
    <div class="bgc container" v-show="cartList.length>0" :class="headIsFixed?'top':''">
      <div class="cart-box shop-container bgw">
        <div class="cart-head item-row">
          <div class="cart-check">
            <input
              type="checkbox"
              class="checkbox-icon"
              @click="handleCheckAll"
              v-model="checkedAll"
            >
            全选
          </div>
          <div class="cart-img">&nbsp;</div>
          <div class="cart-name">商品信息</div>
          <div class="cart-info"></div>
          <div class="cart-price">单价</div>
          <div class="cart-num">数量</div>
          <div class="cart-total">小计</div>
          <div class="cart-handle">操作</div>
        </div>
        <div class="cart-body">
          <div class="item-box" v-for="(item,index) in allCartList" :key="item.id">
            <div class="item-row">
              <div class="cart-check">
                <input
                  type="checkbox"
                  class="checkbox-icon"
                  v-model="item.is_select"
                  :value="item.id"
                  @change="changeSelectGoods"
                >
              </div>
              <div class="cart-img">
                <img :src="item.products.image_path" alt>
              </div>
              <div class="cart-name">
                <p>{{item.products.name}}</p>
                <span
                  class="tag"
                  v-for="(tag,i) in item.products.promotion_list"
                  :key="i"
                >{{tag}}</span>
              </div>
              <div class="cart-info">
                <template v-if="item.products.spes_desc">
                  <div
                    v-for="(spe,i) in item.products.spes_desc.split(',')"
                    :key="i"
                    style="margin-bottom:10px;"
                  >{{spe}}</div>
                </template>
              </div>
              <div class="cart-price">{{item.products.price}}元</div>
              <div class="cart-num">
                <el-input-number
                  v-model="item.nums"
                  @change="handleCount($event,item)"
                  :min="1"
                  label="购买数量"
                  size="small"
                  :max="item.products.stock"
                ></el-input-number>
              </div>
              <div class="cart-total">{{ (item.nums*item.products.price).toFixed(2)}}元</div>
              <div class="cart-handle">
                <i class="icon iconfont iconchenghao" title="删除" @click="removeShop(index,item.id)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bgw shop-container">
        <div class="cart-discount">
          <div class="old">
            商品总金额：
            <span>{{moneyFormat(goodsTotalAmount)}}</span>
          </div>
          <div class="discount" v-show="goodsPmt>0">
            商品优惠：
            <span>{{moneyFormat(goodsPmt)}}</span>
          </div>
          <div class="discount" v-show="orderPmt>0">
            订单优惠：
            <span>{{moneyFormat(orderPmt)}}</span>
          </div>
        </div>
        <div class="cart-foot-total" ref="footFixed" :class="footIsFixed?'hidden':''">
          <div class="go-shop" @click="goShopping">继续购物</div>
          <div class="num-box">
            共
            <span class="total-num">{{cartNums}}</span>件商品，已选择
            <span class="checked-num">{{checkedNums}}</span>件
          </div>
          <div class="go-pay" :class="{'active':checked.length>0}">
            <div @click="placeOrder">去结算</div>
          </div>
          <div class="price-box">
            合计：
            <span class="total-price">{{goodsTotalPrice}}</span>元
          </div>
        </div>
        <div class="cart-foot-total fixed" :class="footIsFixed?'active':''">
          <div class="go-shop" @click="goShopping">继续购物</div>
          <div class="num-box">
            共
            <span class="total-num">{{cartNums}}</span>件商品，已选择
            <span class="checked-num">{{checkedNums}}</span>件
          </div>
          <div class="go-pay" :class="{'active':checked.length>0}">
            <div @click="placeOrder">去结算</div>
          </div>
          <div class="price-box">
            合计：
            <span class="total-price">{{goodsTotalPrice}}</span>元
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CartHead from "@/components/cart/CartHead.vue";
import { formatMoney } from "@/utils";
import throttle from "lodash.throttle";
export default {
  name: "MyCart",
  components: { CartHead },
  props: {},
  data() {
    return {
      buyNum: 1,
      checkall: false,
      cartIds: [],
      cartList: [],
      goodsTotalPrice: 0, //合计
      goodsTotalAmount: 0, //商品总金额
      goodsPmt: 0, //商品总优惠
      orderPmt: 0, //订单总优惠

      headIsFixed: false, //是否吸顶
      footIsFixed: false,
      headOffsetTop: 0,
      footOffsetTop: 0,
      cartNums: 0
    };
  },
  computed: {
    checkedAll: {
      get() {
        if (this.checked.length == this.cartList.length || this.checkall) {
          return true;
        } else {
          return false;
        }
      },
      set() {}
    },
    allCartList: function() {
      return this.cartList;
    },
    checked() {
      let checked = [];
      this.cartList.forEach(item => {
        if (item.is_select) {
          checked.push(item.id);
        }
      });
      return checked;
    },
    moneyFormat() {
      return money => {
        return formatMoney(money);
      };
    },
    checkedNums() {
      let nums = 0;
      this.cartList.forEach(item => {
        if (item.is_select) {
          nums += Number(item.nums);
        }
      });
      return nums;
    }
  },
  methods: {
    //去结算
    placeOrder() {
      if (this.checked.length > 0) {
        let cart_ids = this.checked.join(",");
        this.$router.push({
          name: "order",
          query: { cart_ids: JSON.stringify(cart_ids) }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请选择要结算的商品",
          type: "warning"
        });
      }
    },
    changeSelectGoods() {
      let cartIds = Object.assign([], this.checked);
      if (cartIds.length == 0) {
        return this.resetNumsData();
      }
      this.cartIds = cartIds;
      this.getCartIds();
    },
    getCartIds() {
      this.getCartList();
    },
    resetNumsData() {
      this.goodsTotalAmount = "0.00";
      this.goodsPmt = "0.00";
      this.orderPmt = "0.00";
      this.goodsTotalPrice = "0.00";
    },
    handleCheckAll() {
      if (this.checkedAll) {
        this.cartIds = [];
        this.cartList.forEach(item => {
          item.is_select = false;
        });
        this.resetNumsData();
      } else {
        this.cartIds = [];
        this.cartList.forEach(item => {
          this.cartIds.push(item.id);
        });
        this.getCartIds();
      }
    },
    removeShop(index, id) {
      this.cartList.splice(index, 1);
      let data = {
        ids: id
      };
      this.$api.removeCart(data).then(res => {
        if (res.status) {
          this.getCartList();
          this.getCartNums();
        }
      });
    },
    handleCount: throttle(function(num, item) {
      if (!item.is_select) return false;
      //数量需要加控制
      let data = {
        id: item.id,
        nums: num
      };
      this.$api.setCartNum(data).then(res => {
        if (res.status) {
          this.getCartList();
          this.getCartNums();
        }
      });
    }, 300),
    getCartNums() {
      this.$api.getCartNum().then(res => {
        if (res.status) {
          this.cartNums = res.data;
        }
      });
    },
    //获取购物车列表
    getCartList() {
      let cartIds = this.cartIds.toString();
      let data = {
        ids: cartIds,
        display: "all"
      };
      this.$api.cartList(data).then(res => {
        if (res.status) {
          this.goodsTotalAmount = res.data.goods_amount;
          this.goodsPmt = res.data.goods_pmt;
          this.orderPmt = res.data.order_pmt;
          this.goodsTotalPrice = res.data.amount;
          this.cartList = res.data.list;
        }
      });
    },
    goShopping() {
      this.$router.push({ name: "search" });
    },
    initHeight:throttle(function(){
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.headIsFixed = scrollTop > this.headOffsetTop ? true : false;
    },200),
    initFootTop: throttle(function() {
      let that = this;
      that.$nextTick(() => {
        let isVisible = that.elementIsVisibleInViewport(that.$refs.footFixed);
        that.footIsFixed = !isVisible;
      });
    }, 200),
    elementIsVisibleInViewport(el, partiallyVisible = false) {
      const { top, left, bottom, right } = el.getBoundingClientRect();
      const { innerHeight, innerWidth } = window;
      return partiallyVisible
        ? ((top > 0 && top < innerHeight) ||
            (bottom > 0 && bottom < innerHeight)) &&
            ((left > 0 && left < innerWidth) ||
              (right > 0 && right < innerWidth))
        : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
    }
  },
  created() {},
  mounted() {
    if (this.$storage.get("userToken")) {
      this.getCartList();
      this.getCartNums();
    }
    window.addEventListener("scroll", this.initHeight);
    window.addEventListener("scroll", this.initFootTop);
    this.$nextTick(() => {
      this.headOffsetTop = document.querySelector("#headFixed").offsetTop;
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.initHeight);
    window.removeEventListener("scroll", this.initFootTop);
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
@import "@/assets/css/mixin.scss";
.cart-empty {
  height: 200px;
  padding: 30px 0;
  text-align: center;
  h2 {
    font-size: 24px;
    margin-bottom: 20px;
  }
  .btn {
    margin: 0 auto;
    width: 170px;
    height: 48px;
    line-height: 48px;
    background: $theme-color;
    color: #fff;
    text-align: center;
    a{
      display: block;
    }
  }
}
#headFixed {
  &.isfixed {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 999;
  }
}
.container{
  padding-top:30px;
  &.top{
    margin-top:100px;
  }
}
.cart-box {
  margin-bottom: 20px;
  .item-box {
    border-top: 1px solid $border;
    padding: 15px 26px 15px 0;
  }
  .item-row {
    display: flex;
    align-items: center;
    &.cart-head {
      @include line-height(70px);
      padding-right: 26px;
    }
    .cart-check {
      width: 100px;
      .checkbox-icon {
        display: inline-block;
        width: 22px;
        height: 22px;
        @include bg-url("~@/assets/icon/checkbox.png");
        @include bg-full();
        margin-left: 24px;
        margin-right: 10px;
        vertical-align: middle;
        position: relative;
        top: -2px;
        cursor: pointer;
        transition: all 0.2s;
        &:checked {
          width: 22px;
          height: 22px;
          @include bg-url("~@/assets/icon/checkbox_checked.png");
        }
      }
    }
    .cart-img {
      width: 80px;
      height: 80px;
      padding-right: 20px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .cart-name {
      flex: 1;
      margin-right: 20px;
      p {
        line-height: 1.4;
      }
      .tag {
        padding: 1px 10px;
        color: #fff;
        background: $theme-color;
        font-size: 12px;
        margin-right: 10px;
      }
    }
    .cart-info {
      width: 180px;
      color: #757575;
      font-size: 12px;
    }
    .cart-price {
      width: 100px;
      padding-right: 30px;
      text-align: right;
    }
    .cart-num {
      width: 150px;
      text-align: center;
      position: relative;
      .stockStatus {
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        font-size: 12px;
        color: #757575;
      }
    }
    .cart-total {
      width: 100px;
      padding-right: 30px;
      text-align: right;
      color: $theme-color;
    }
    .cart-handle {
      width: 80px;
      text-align: center;
      .icon {
        font-size: 18px;
        cursor: pointer;
        border-radius: 50%;
        transition: all 0.2s;
        padding: 4px;
        &:hover {
          background: $theme-color;
          color: #fff;
        }
      }
    }
  }
}
.cart-discount {
  padding: 15px 30px;
  text-align: right;
  .old,
  .discount {
    line-height: 24px;
    span {
      color: $theme-color;
      display: inline-block;
      min-width: 70px;
    }
  }
}
.cart-foot-total {
  @include line-height(50px);
  margin-bottom: 20px;
  border-top: 1px solid $border;
  visibility: visible;
  .go-shop {
    float: left;
    padding: 0 20px;
    cursor: pointer;
    color: #757575;
  }
  .num-box {
    float: left;
    color: #757575;
    .total-num,
    .checked-num {
      color: $theme-color;
      margin-right: 3px;
    }
  }
  .price-box {
    float: right;
    color: $theme-color;
    height: 50px;
    .total-price {
      font-size: 30px;
    }
  }
  .go-pay {
    float: right;
    width: 200px;
    color: #fff;
    background: #757575;
    text-align: center;
    margin-left: 40px;
    cursor: pointer;
    &.active {
      background: $theme-color;
    }
  }
  &.hidden {
    visibility: hidden;
  }
  &.fixed {
    width: 1226px;
    position: fixed;
    left: 50%;
    margin-left: -613px;
    margin-bottom: 0;
    bottom: 0;
    z-index: 999;
    background-color: #fafafa;
    -webkit-box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.1);
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.1);
    visibility: hidden;
    &.active {
      visibility: visible;
    }
  }
}
</style>